import '@hotwired/turbo-rails'
import { Dropdown, Collapse, Tab } from 'bootstrap'
import '../controllers/index'

Array.from(document.querySelectorAll('.dropdown-toggle')).map(n => new Dropdown(n))
Array.from(document.querySelectorAll('.collapse')).map(n => new Collapse(n, { toggle: false }))
